module.exports = __webpack_public_path__ + "static/media/logo_sin_texto.3fd25ede.png";